import { getWindow } from "shared/lib/utils";

export const getLocalstorageExtraInformation = () => {
  if (!getWindow()) return {};
  return Object.entries(localStorage).reduce(
    (accumulator, [key, value]) => {
      accumulator[key] = new Blob([value]).size;
      return accumulator;
    },
    {} as Record<string, unknown>,
  );
};
